import React from 'react';
import Violin_Ipad from '../../assets/images/Violin_Ipad.jpg';
const ViolinIpad = () => {
  return (
    <img
      src={Violin_Ipad}
      className="violinipad"
      alt="violinipad"
      style={{ width: '100vw', height: '600px' }}
    />
  );
};

export default ViolinIpad;
